import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { highlight } from "@Shared/@Utils/utils";
import { isEmpty } from "lodash";
import numeral from "numeral";
import { defineComponent } from "@vue/composition-api";
import { openWidgetPopover } from "@Shared/@Utils/vue/directives/open-window-popover";
import moment from "moment";
export default defineComponent({
  name: "ResponseDetails",
  props: {
    currentResponse: {
      type: Object,
      default: () => ({})
    },
    focusedElement: {
      type: String,
      default: ""
    },
    externalTab: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    emptyDeclineData() {
      var _this$currentResponse;
      const declineData = (_this$currentResponse = this.currentResponse.lenderResponse) == null ? void 0 : _this$currentResponse.declineData;
      return declineData && isEmpty(declineData.denialNotes) && isEmpty(declineData.denialReason);
    },
    details() {
      if (isEmpty(this.currentResponse)) return {};
      const {
        lenderResponse,
        submissionDetails,
        status
      } = this.currentResponse;
      if (this.emptyDeclineData) delete lenderResponse.declineData;
      let response = _objectSpread(_objectSpread({}, lenderResponse), {}, {
        submissionDetails
      });

      // responseDetails

      if (response != null && response.responseDetails) {
        const rDetails = lenderResponse.responseDetails;
        if (this.checkIfPropertyExists(rDetails, "rate") && !isNaN(rDetails.rate) && rDetails.rate !== null) {
          response.responseDetails.rate = _parseFloat(rDetails.rate.toString()).toFixed(2) + "%";
        }
        if (this.checkIfPropertyExists(rDetails, "totalMortgageAmount")) {
          response.responseDetails.totalMortgageAmount = numeral(rDetails.totalMortgageAmount).format("$ 0,0.00");
        }
        if (this.checkIfPropertyExists(rDetails, "mortgageAmount")) {
          response.responseDetails.mortgageAmount = numeral(rDetails.mortgageAmount).format("$ 0,0.00");
        }
        if (this.checkIfPropertyExists(rDetails, "payment")) {
          response.responseDetails.payment = numeral(rDetails.payment).format("$ 0,0.00");
        }
        if (this.checkIfPropertyExists(rDetails, "mortgageInsurance")) {
          response.responseDetails.mortgageInsurance = numeral(rDetails.mortgageInsurance).format("$ 0,0.00");
        }
        if (this.checkIfPropertyExists(rDetails, "miPremiumPst") && !isNaN(rDetails.miPremiumPst) && rDetails.miPremiumPst !== null) {
          response.responseDetails.miPremiumPst = "$" + _parseFloat(rDetails.miPremiumPst.toString()).toFixed(2);
        }
        if (this.checkIfPropertyExists(rDetails, "commitmentIssueDateTimeISO") && rDetails.commitmentIssueDateTimeISO) {
          const commitmentDate = response.responseDetails.commitmentIssueDateTimeISO;
          response.responseDetails.commitmentIssueDateTimeISO = moment(commitmentDate).format("MMMM Do YYYY @ HH:mm:ss");
        }
      }

      // applicationSummary\
      response.applicationSummary.applicationStatus = status || "";
      delete response.applicationSummary.applicationStatusDate;
      if (response.applicationSummary && this.currentResponse.applicationSource) {
        response.applicationSummary.applicationSource = this.currentResponse.applicationSource;
      }
      if (this.checkIfPropertyExists(response.applicationSummary, "totalLoanAmount")) {
        response.applicationSummary.totalLoanAmount = numeral(lenderResponse.applicationSummary.totalLoanAmount).format("$ 0,0.00");
      }
      // submissionDetails

      if (response != null && response.submissionDetails) {
        if (this.checkIfPropertyExists(submissionDetails, "rate")) {
          response.submissionDetails.rate = _parseFloat(submissionDetails.rate.toString()).toFixed(2) + "%";
        }
        if (this.checkIfPropertyExists(submissionDetails, "mortgageInsurance")) {
          response.submissionDetails.mortgageInsurance = numeral(submissionDetails.mortgageInsurance).format("$ 0,0.00");
        }
        if (this.checkIfPropertyExists(submissionDetails, "mortgageAmount")) {
          response.submissionDetails.mortgageAmount = numeral(submissionDetails.mortgageAmount).format("$ 0,0.00");
        }
        if (this.checkIfPropertyExists(submissionDetails, "payment")) {
          response.submissionDetails.payment = numeral(submissionDetails.payment).format("$ 0,0.00");
        }
        if (this.checkIfPropertyExists(submissionDetails, "totalMortgageAmount")) {
          response.submissionDetails.totalMortgageAmount = numeral(submissionDetails.totalMortgageAmount).format("$ 0,0.00");
        }
      }
      return response;
    },
    sectionTitle() {
      return {
        lenderInformation: this.$t("direct-to-lender.lenderSubmit.lenderInformation"),
        responseDetails: this.$t("direct-to-lender.lenderSubmit.responseDetails"),
        applicationSummary: this.$t("direct-to-lender.lenderSubmit.applicationSummary"),
        responseNotes: this.$t("direct-to-lender.lenderResponse.responseNotes"),
        submissionDetails: this.$t("direct-to-lender.lenderResponse.submissionDetails"),
        denialNotes: this.$t("direct-to-lender.lenderResponse.denialNotes"),
        denialReason: this.$t("direct-to-lender.lenderResponse.denialReason"),
        declineData: this.$t("direct-to-lender.lenderResponse.declineData")
      };
    }
  },
  mounted() {
    if (this.focusedElement) this.scrollTo(this.focusedElement);
  },
  methods: {
    goBack() {
      this.$emit("back");
    },
    scrollTo(element) {
      this.$nextTick(() => {
        this.$scrollTo(element, 2000, {
          container: "#app-data-container",
          force: true,
          cancelable: true
        });
        highlight($(element), {
          delay: 850
        });
      });
    },
    getSectionTitle(sectionKey) {
      return this.sectionTitle[sectionKey] || this.$t(`response-information.${sectionKey}`);
    },
    checkIfPropertyExists(source, property) {
      return Object.prototype.hasOwnProperty.call(source, property);
    },
    windowPopoverUrl() {
      const {
        agentUsername,
        clientUsername,
        applicationId
      } = this.$route.params;
      return `#/widgets/applications/${applicationId}/client/${clientUsername}/agent/${agentUsername}/lender-response-details/${this.currentResponse.submissionId}`;
    },
    requestSubmitConfirmation() {
      openWidgetPopover(this, {
        url: this.windowPopoverUrl(),
        width: 900,
        height: 600
      });
    }
  }
});